import React from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import serverData, { init as initServerData } from './utils/server-data'
import { ContextProvider as WorldReadyContextProvider } from '@paypalcorp/worldready-react'
import reportWebVitals from './utils/reportWebVitals'

initServerData()
let rootElement = document.getElementById('root')

if (!rootElement) {
  rootElement = document.createElement('div')
  document.body.appendChild(rootElement)
}

const root = createRoot(rootElement)
root.render(
  <WorldReadyContextProvider locale={serverData.locality.locale}>
    <App path="*" />
  </WorldReadyContextProvider>,
)

reportWebVitals()
